import { render, staticRenderFns } from "./TicketComponent.vue?vue&type=template&id=464467b3"
import script from "./TicketComponent.vue?vue&type=script&lang=ts"
export * from "./TicketComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports